'use strict';

import type { UserMeta } from '../../Entities/User/UserMeta';
import { EntityCollection } from '../EntityCollection';

export class UserMetaCollection extends EntityCollection<UserMeta> {}
